export enum ExternalCompanyIdEnum {
  EIE = '264',
  EIE_VISMA = '47', // TODO = check with production
  SORMEGLEREN = 'MSSORM',
  PROACTIV = '284',
  BRORBY = '?',
  SMG = 'MDAtMXwwMDAwMDAwMjMwM3wyODQ.',
  MSPECS = 'MDAtMXwwMDAwMDAwMjQ0N3wyODQ.',
  FREMEIENDOMSMEGLING = '340',
  STRAND_MAKLERI = 'MDAtMXwwMDAwMDAwMjcyNnwyODQ.',
  STUDIO_FASTIGHETSMAKLERI = 'MDAtMXwwMDAwMDAwMjcyN3wyODQ.',
  HOME_BY_DEAN = 'MDAtMXwwMDAwMDAwMjcyOXwyODQ.',
  MAKLARTEAMET = 'MDAtMXwwMDAwMDAwMjc2MHwyODQ.',
  WALLIN_CO_FASTIGHETSMAKLARE_AB = 'MDAtMXwwMDAwMDAwMjcyNXwyODQ.',
  H_MAKLARE_AB = 'MDAtMXwwMDAwMDAwMjc2OHwyODQ.',
  CHRISTANDER = 'MDAtMXwwMDAwMDAwMjc1OXwyODQ.',
  EIENDOM_BROERBY = '284',
  VISBYMAKLARNA_AB = 'MDAtMXwwMDAwMDAwMjgwMHwyODQ.',
  SKOG_LANTBRUK_AB = 'MDAtMXwwMDAwMDAwMjgwMnwyODQ.',
  LIWE_ESTATE = 'MDAtMXwwMDAwMDAwMjgwOXwyODQ.',
  SJOLINSMAKLARE = 'MDAtMXwwMDAwMDAwMjgxNXwyODQ.',
  EMERA_EIE = 'MSEMERA',
  HETTINGER = 'MDAtMXwwMDAwMDAwMjg0NXwyODQ.',
  GRIPSHOLM = 'MDAtMXwwMDAwMDAwMjkxOXwyODQ.',
  BOSTADSBYRAN = 'MDAtMXwwMDAwMDAwMjkxMnwyODQ.',
  BERGGREN = 'MDAtMXwwMDAwMDAwMjgzNXwyODQ.',
  BOSTADA = 'MDAtMXwwMDAwMDAwMjgzMnwyODQ.',
  MARSTAMAKLARHUS = 'MDAtMXwwMDAwMDAwMjk3N3wyODQ.',
  CEYLANSANDBERG = 'MDAtMXwwMDAwMDAwMjk1OHwyODQ.',
  HEKTARTUNNLAND = 'MDAtMXwwMDAwMDAwMzA0MHwyODQ.',
  UNIKAHEM = 'MDAtMXwwMDAwMDAwMjk4NHwyODQ.',
  SKOGSMAKLARGRUPPEN = 'MDAtMXwwMDAwMDAwMzAwM3wyODQ.',
  OBOS = '196',
}
